export const MIN_LENGTH_STAGENAME = 1;

export const MAX_LENGTH_STAGENAME = 51;
